import React from "react"

import BasePermissionGate, { BasePermissionGateProps } from "@/components/PermissionGate/BasePermissionGate"

const CustomFieldGroupPermissionGate = (props: Omit<BasePermissionGateProps<"custom-field">, "feature">) => {
	return (
		<BasePermissionGate
			{...props}
			feature="custom-field"
		/>
	)
}

export default CustomFieldGroupPermissionGate
